module.exports = __webpack_public_path__ + "static/media/gary-green.bd75966b.png";